import { api } from '../api';

/**
 * As chamadas do ISC, com os caminhos escritos por extenso.
 *
 * Mesmo motivo dos outros módulos: o caminho é o contrato entre a tela e
 * a API, e contrato se lê. Quem procurar `/isc/corpos` no projeto acha
 * esta linha, e o teste `26` — que confere se toda rota de criação tem
 * caminho literal na interface — consegue enxergá-la.
 */

export interface EnsaioIsc {
  cabecalho: any;
  corpos: any[];
  expansao: any[];
  penetracao: any[];
  equipamentos: any[];
  compactacoes: any[];
  pontosDisponiveis: any[];
  pressoesPadrao: any[];
  tabelaNorma: any[];
  pendencias: string[];
  pendenciasDetalhadas?: any[];
  /** A tentativa da repetição aberta, se houver (onda 323). */
  repeticaoAberta?: number | null;
}

export const verIsc = (id: string) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc`);

export const gravarIscCabecalho = (id: string, corpo: unknown) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc`, { metodo: 'PUT', corpo });

/**
 * O ISC adotado — a única chamada deste módulo que grava uma DECISÃO.
 *
 * Vai separada do cabeçalho de propósito, e exige permissão de processar,
 * não de lançar: digitar uma carga é trabalho de bancada, escolher o ISC
 * do ensaio é ato técnico com nome de quem assina (NBR 9895, 6.4.2).
 */
export const adotarIsc = (id: string, corpo: unknown) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/adotado`, { metodo: 'POST', corpo });

export const gravarIscCorpos = (id: string, corpo: unknown) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/corpos`, { metodo: 'POST', corpo });

export const descartarIscCorpo = (id: string, cid: string, motivo: string) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/corpos/${cid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });

export const gravarIscExpansao = (id: string, cid: string, corpo: unknown) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/corpos/${cid}/expansao`,
    { metodo: 'POST', corpo });

export const gravarIscPenetracao = (id: string, cid: string, corpo: unknown) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/corpos/${cid}/penetracao`,
    { metodo: 'POST', corpo });

export const descartarIscPenetracao = (
  id: string, lid: string, motivo: string,
) =>
  api<EnsaioIsc>(`/ensaios/${id}/isc/penetracao/${lid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });
